import con1 from "../assets/imgs/post/1.png";
import con2 from "../assets/imgs/post/2.png";
import con3 from "../assets/imgs/post/3.png";
import pro1 from "../assets/imgs/profile/1.png";
import pro2 from "../assets/imgs/profile/2.png";
import pro3 from "../assets/imgs/profile/3.png";
import pro4 from "../assets/imgs/profile/4.png";

export const posts = [
  {
    id: "1",
    icons: "✍️",
    category: "Article",
    contentImg: con1,
    title: "What if famous brands had regular fonts? Meet RegulaBrands!",
    describe:
      "I’ve worked in UX for the better part of a decade. From now on, I plan to rei…",
    name: "Sarthak Kamra",
    profileImg: pro1,
    date: "",
    location: "",
    link: "",
  },
  {
    id: "2",
    icons: "🔬️",
    category: "Education",
    contentImg: con2,
    title:
      "Tax Benefits for Investment under National Pension Scheme launched by Government",
    describe:
      "I’ve worked in UX for the better part of a decade. From now on, I plan to rei…",
    name: "Sarah West",
    profileImg: pro2,
    date: "",
    location: "",
    link: "",
  },
  {
    id: "3",
    icons: "🗓️",
    category: " Meetup",
    contentImg: con3,
    title: "Finance & Investment Elite Social Mixer @Lujiazui",
    describe: "",
    name: "Sarah West",
    profileImg: pro3,
    date: "Fri, 12 Oct, 2018",
    location: "Ahmedabad, India",
    link: "Visit Website",
  },
  {
    id: "4",
    icons: "💼️",
    category: "Job",
    contentImg: "",
    title: "Software Developer",
    describe: "",
    name: "Sarah West",
    profileImg: pro4,
    date: "Innovaccer Analytics Private Ltd.",
    location: "Noida, India",
    link: "Apply on Timesjobs",
    company: "Innovaccer Analytics Private Ltd.",
  },
];
